import {create} from 'zustand';

interface ScrollPositionState {
  positions: Record<string, number>;
}

const initialState: ScrollPositionState = {
  positions: {},
};

const scrollPositionStore = create<ScrollPositionState>(() => initialState);

export const scrollPositionActions = {
  setScrollPosition: (key: string, position: number) =>
    scrollPositionStore.setState((state) => ({
      positions: {
        ...state.positions,
        [key]: position,
      },
    })),
  getScrollPosition: (key: string) =>
    scrollPositionStore.getState().positions[key] || 0,
  clearScrollPosition: (key: string) =>
    scrollPositionStore.setState((state) => {
      const {[key]: _, ...rest} = state.positions;
      return {positions: rest};
    }),
  clearAll: () => scrollPositionStore.setState({positions: {}}),
};

export default scrollPositionStore;
